import { REFERRER_API_URL } from '@constants/referrer';
import { SessionStorageHandler } from '@helpers/session-storage.ts';
import type {
  AttendeeQueryType,
  InterviewSessionQueryKeyType,
} from '@interfaces/session';

export class InterviewSession {
  static keySet: InterviewSessionQueryKeyType[] = [
    'name',
    'certificationCode',
    'valuerSn',
    'intervieweeName',
    'apiUrl',
    'refUrl',
    'nameBlindYn',
    'type',
    'pathName',
  ];
  private static sessionStorageHandler: SessionStorageHandler;

  constructor() {
    InterviewSession.sessionStorageHandler = new SessionStorageHandler();
  }

  public saveInterviewInfo() {
    const params = new URLSearchParams(location.search);

    if (InterviewSession.keySet.some((key) => params.has(key))) {
      const payload = {
        name: params.get('name') ?? '',
        certificationCode: params.get('certificationCode') ?? '',
        valuerSn: params.get('valuerSn') ?? '',
        intervieweeName: params.get('intervieweeName')
          ? (params.get('intervieweeName') ?? '')
          : (params.get('name') ?? ''),
        refUrl: params.get('refUrl') ?? REFERRER_API_URL.origin,
        apiUrl: params.get('apiUrl') ?? REFERRER_API_URL.hostname,
        nameBlindYn: params.get('nameBlindYn') ?? '',
      };

      InterviewSession.sessionStorageHandler.bulkUpdateWithObject(payload);
    }
  }

  public getInterviewInfo() {
    return InterviewSession.sessionStorageHandler.bulkReadWithArray(
      InterviewSession.keySet,
    ) as AttendeeQueryType;
  }
}

export class CameraSession {
  private static sessionStorageHandler: SessionStorageHandler;

  constructor() {
    CameraSession.sessionStorageHandler = new SessionStorageHandler();
  }

  public saveCameraState(state: string) {
    CameraSession.sessionStorageHandler.setItem('camera', state);
  }

  public getCameraState() {
    return CameraSession.sessionStorageHandler.getItem('camera');
  }
}
